import React from 'react';
import './Sales.css';

import mapImageUrl from '../assets/img/map.svg'; // Ensure this path is correct

const SalesPage = () => {
  const countries = [
    "Turkey", "Hungary", "Portugal", "Italy", "Germany", "Finland",
    "USA", "Spain", "Belgium", "Lithuania", "France", "Sweden",
    "Greece", "Poland", "Czech Republic", "Slovakia", "Romania", "The Netherlands"
  ];

  return (
    <div className="sales-page-container">
      <main id="main">
        {/* ======= Breadcrumbs ======= */}
        <section id="breadcrumbs" className="breadcrumbs">
          <div className="container">
            <ol>
              <li><a href="/"><i className="fas fa-home" aria-hidden="true"></i><span className="sr-only">Home</span></a></li>
              <li>Sales Network</li>
            </ol>
          </div>
        </section>{/* End Breadcrumbs */}

        {/* ======= Sales Network Section ======= */}
        <section className="sales-network-section">
          <div className="container">
            <div className="section-title" data-aos="fade-up">
              <h2>Sales Network</h2>
              <div className="title-bar"></div>
            </div>

            <div className="about-container">
              {/* Content Column now comes FIRST */}
              <div className="content-column">
                <div className="about-card">
                  <h3 className="about-subtitle">Our Global Presence</h3>
                  <p>
                    As <span style={{ color: 'var(--primary-color)', fontWeight: '600' }}>ABP</span>, we operate a direct sales and dealership network across all European countries, with a special focus on Germany, Italy, Spain, France, and the Benelux region.
                  </p>
                  <p>
                    With warehouses and dedicated sales teams in numerous countries, we ensure timely and secure delivery of our products. We also provide comprehensive technical assistance, material support, and product training to our valued customers.
                  </p>
                  <p>
                    Our marketing team is committed to enhancing customer satisfaction through continuous research and strategic initiatives, reinforcing our reputation as a successful and dependable supplier.
                  </p>

                  <p className="countries-title">
                    Countries We Serve:
                  </p>
                  <div className="country-list">
                    {countries.map(country => (
                      <span key={country} className="country-tag">
                        {country}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Image Column now comes AFTER content */}
              <div className="image-column">
                <div className="image-wrapper">
                  <img
                    src={mapImageUrl}
                    alt="Global map illustrating ABP's sales network coverage"
                    className="about-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>{/* End Sales Network Section */}
      </main>
    </div>
  );
};

export default SalesPage;